<template>
    <div>
        <template v-if="complaints">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Complaints Management</h1>
            </div>
            <div class="col-md-12 mt-3 mb-3">
                <statusAnalytics ref="analyticsRef" @statusClicked="handleStatusClick"></statusAnalytics>
            </div>
            <div class="table">
                <table class="table" id="complaintTable" width="100%">
                    <thead>
                    <tr>
                        <th>Ticket No</th>
                        <th>Company Name</th>
                        <th>Subject</th>
                        <th>Priority</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                </table>
            </div>
            <div class="modal fade" id="newBatchModal" role="dialog" tabindex="-1">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="modal-body new-batch-popup pb-4">
                            <div class="popup-head line-head mt-4 mb-3">
                                <h2 class="pb-3">{{this.viewComplaint ? "View Ticket":"Update Ticket"}}</h2>
                            </div>
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 d-flex p-0">
                                        <div class="col-lg-6 col-md-6 col-sm-12 mt-2 p-0 flex-grow-1">
                                            <div class="card" style="padding: 8px; box-shadow: none; height: 100%">
                                                <div class="mb-3" style="border-bottom: 1px dashed #dee2e6;">
                                                    <h3 class="mb-2">Full Name :</h3>
                                                    <p class="mb-3">{{ this.full_name }}</p>
                                                </div>
                                                <div class="mb-3" style="border-bottom: 1px dashed #dee2e6;">
                                                    <h3 class="mb-2">Subject :</h3>
                                                    <p class="mb-3">{{ this.subject }}</p>
                                                </div>
                                                <div class="mb-3" style="border-bottom: 1px dashed #dee2e6;">
                                                    <h3 class="mb-2">Message :</h3>
                                                    <p class="mb-3">{{ this.message }}</p>
                                                </div>
                                                <div class="mb-3" v-if="!viewComplaint">
                                                    <h2 class="mb-2">Comment <em class="required">*</em></h2>
                                                    <textarea class="form-control"
                                                              rows="3"
                                                              style="resize: none; border: #c3c7d1fa dashed 1px;"
                                                              v-model="comment"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 mt-2 flex-grow-1">
                                            <h3>Ticket Log</h3>
                                            <ul class="timeline">
                                                <li>
                                                    <h5>priority</h5>
                                                    <a class="float-right" href="#">{{ this.ticketUpdatedDate }}</a>
                                                    <p>{{ this.ticketpriority }}</p>
                                                </li>
                                                <li>
                                                    <h5 class="d-flex" style="gap:3px">status <em class="required">*</em>
                                                        <div v-if="!viewComplaint">
                                                            <i @click="editStatus" class="fas fa-edit cursor-pointer"
                                                               v-if="!editMode"></i>
                                                            <i @click="cancelEdit" class="fas fa-times cursor-pointer"
                                                               v-if="editMode"></i>
                                                        </div>
                                                    </h5>
                                                    <a class="float-right" href="#">{{ this.ticketUpdatedDate }}</a>
                                                    <p v-if="!editMode">{{ this.ticketStatus }}</p>
                                                    <select class="form-control custom-select2" name="purpose"
                                                            placeholder="Purpose" v-if="editMode"
                                                            v-model="ticketStatus">
                                                        <option selected value="">Select..</option>
                                                        <option value="New">New</option>
                                                        <option value="In Progress">In Progress</option>
                                                        <option value="On Hold">On Hold</option>
                                                        <option value="Resolved">Resolved</option>
                                                        <option value="Closed">Closed</option>
                                                    </select>
                                                </li>
                                                <li>
                                                    <h5>purpose</h5>
                                                    <a class="float-right" href="#">{{ this.ticketUpdatedDate }}</a>
                                                    <p>{{ this.TicketPurpose }}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button @click="updateTicket" class="btn btn-primary float-right active m-0"
                                    v-if="!viewComplaint">Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="complaints == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="complaints == false">
            Sorry this page is not accessable!
        </template>
    </div>
</template>

<script>
    var dtTable = null;
    export default {
        data() {
            return {
                complaints: true,
                edit_complaints: null,
                created_at: '',
                priority: '',
                status: '',
                companiesLeaves: null,
                full_name: '',
                subject: "",
                message: "",
                ticketpriority: "",
                ticketStatus: "",
                TicketPurpose: "",
                ticketUpdatedDate: '',
                editMode: false,
                editedStatus: '',
                originalStatus: "",
                complaintId: '',
                viewComplaint: false,
                editComplaint: false,
                comment: '',
                filteredStatus: '',
            };
        },
        mounted() {
            this.$Progress.start();
            $('#complaintTable').on('click', '.view-complaint', this.handleViewComplaint);
            $('#newBatchModal').on('hidden.bs.modal', () => {
                this.viewComplaint = false;
            });
            $('#newBatchModal .close').on('click', () => {
                this.viewComplaint = false;
            });
            this.can('edit_complaints').then(result => {
                if (result.edit_complaints == true) {
                    this.edit_complaints = true;
                } else {
                    this.getComplaintHistory();
                    this.edit_complaints = false;
                }
            }).then(result => {
                if (this.edit_complaints == true) {
                    this.getComplaintHistory();
                    this.$Progress.finish();
                } else {
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            filterTable() {
                this.$Progress.start();
                this.dtTable.draw();
                this.$Progress.finish();
            },
            getComplaintHistory: function () {
                const editcomplaints = this.edit_complaints
                var that = this;
                that.dtTable = $('#complaintTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom: '<"row pb-3 view-filter"<"col-md-12 pr-4 pl-4 text-right"f>><"table-holder mb-3"t><"row mb-3 view-pager"<"col-sm-4 pl-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 pr-4 text-right"l>>r',
                    ajax: {
                        "url": "api/allEnquiry",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        'data': function (data) {
                            data.status = that.filteredStatus || '';
                            return data;
                        },
                        "complete": function (json, type) {
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            } else {
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {
                            data: 'id',
                            sorting: false,
                            render: function (data, type, full) {
                                return '<p data-complaint-id="${full.id}"   data-placement="top" title="" class=" view" data-original-title="View" style="color: rgb(115, 103, 240);">TKT_' + full.id + '</p>';
                            }
                        },
                        {
                            data: 'name',
                            sorting: false,
                            render: function (data, type, full) {
                                if (full.user && full.user.company && full.user.company.name) {
                                    return '<p data-complaint-id="${full.id}" data-placement="top" title="" class="view" data-original-title="View">' + full.user.company.name + '</p>';
                                } else {
                                    return '';
                                }
                            }
                        },

                        {data: 'customer_details'},
                        {
                            data: 'priority',
                            render: function (data, type, full) {
                                return '<span class="badge badge-pill badge-primary">' + full.priority + ' </span>';
                            }
                        },
                        {
                            data: 'created_at', render: function (data, type, full) {
                                return moment(full.created_at).format('YYYY-MM-DD hh:mm A');
                            }
                        },
                        {
                            data: 'updated_at', render: function (data, type, full) {
                                return moment(full.updated_at).format('YYYY-MM-DD hh:mm A');
                            }
                        },
                        {
                            data: 'status',
                            render: function (data, type, full) {
                                return '<span class="badge badge-pill badge-secondary">' + full.status + ' </span>';
                            }
                        },
                        {
                            data: 'id',
                            sorting: false,
                            render: function (data, type, full) {
                                if (full.status === 'Resolved') {
                                    return `<p data-complaint-id="${full.id}" data-action="view" class="view-complaint action" title="View"><i class="fas fa-eye"></i></p>`;
                                } else if (editcomplaints == true) {
                                    return `<p data-complaint-id="${full.id}" data-action="view" class="view-complaint action" title="View"><i class="fas fa-eye"></i></p>
                                    <p data-complaint-id="${full.id}" data-action="edit" class="view-complaint action" title="Edit"><i class="fas fa-pencil-alt"></i></p>`;
                                } else {
                                    return `<p data-complaint-id="${full.id}" data-action="view" class="view-complaint action" title="View"><i class="fas fa-eye"></i></p>`;
                                }
                            }
                        },

                    ],
                    "order": [[0, "desc"]],
                });
            },
            handleViewComplaint(event) {
                const complaintId = $(event.currentTarget).data('complaint-id');
                const action = $(event.currentTarget).data('action');
                if (action === 'view') {
                    this.viewComplaint = true
                    this.getsingleComplaintrecord(complaintId);

                } else if (action === 'edit') {
                    this.editComplaint = true
                    this.getsingleComplaintrecord(complaintId);
                }
                $('#newBatchModal').modal('show');

            },
            getsingleComplaintrecord(id) {
                this.$Progress.start();
                axios.get('/api/viewEnquiry/' + id)
                    .then(res => {
                        this.$Progress.finish();
                        this.full_name = res.data.fullname,
                            this.subject = res.data.customer_details,
                            this.comment = res.data.comment,
                            this.message = res.data.message,
                            this.ticketpriority = res.data.priority,
                            this.ticketStatus = res.data.status,
                            this.TicketPurpose = res.data.purpose,
                            this.ticketUpdatedDate = moment(res.data.updated_at).format('YYYY-MM-DD');
                        this.complaintId = res.data.id
                        this.$Progress.finish();
                    }).then(res => {
                    $('.selectpicker').selectpicker();
                }).catch(err => {
                    console.log(err);
                });
            },
            updateTicket() {
                const updatedData = {
                    id: this.complaintId,
                    status: this.ticketStatus,
                    comment: this.comment,
                };
                this.$Progress.start();
                axios.put('/api/updateEnquiry', updatedData)
                    .then(res => {
                        $('#newBatchModal').modal('hide');
                        this.showToastBox(
                            'success',
                            'Your Complaint has been updated successfully'
                        );
                        this.$refs.analyticsRef.getStatusAnalytics();
                        $('#complaintTable').DataTable().ajax.reload()
                        this.$Progress.finish();
                    }).catch(errors => {
                    const errorMessages = Object.entries(errors.response.data.errors)
                        .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                        .join('\n');
                    this.showAlertBox('error', `Validation errors:\n${errorMessages}`);
                });
            },
            editStatus() {
                this.editMode = true;
                this.originalStatus = this.ticketStatus;
            },
            cancelEdit() {
                this.editMode = false;
                this.editedStatus = this.originalStatus;
            },
            handleStatusClick(status) {
                this.filteredStatus = status;
                this.dtTable.search(this.filteredStatus).columns().search('').draw();
                this.getComplaintHistory();
            },
        },
    }
</script>
<style>
    .badge-primary {
        color: #28c76f !important;
        background-color: rgba(40, 199, 111, .12) !important;
        padding: 12px;
        border-radius: 10px;
    }

    .badge-secondary {
        color: #00cfe8;
        background-color: rgba(0, 207, 232, .12);
        padding: 12px;
        border-radius: 10px;
    }

    ul.timeline:before {
        content: ' ';
        background: #d4d9df;
        display: inline-block;
        position: absolute;
        left: 20px;
        width: 2px;
        height: 80%;
        z-index: 400;
    }

    ul.timeline > li {
        margin: 25px 0;
        padding-left: 20px;
    }

    ul.timeline {
        list-style-type: none;
        position: unset;
        padding-left: 10px;
    }

    ul.timeline > li:before {
        content: ' ';
        background: white;
        display: inline-block;
        position: absolute;
        border-radius: 50%;
        border: 5px solid #eb401f;
        left: 11px;
        width: 20px;
        height: 20px;
        z-index: 400;
    }

    h5 {
        text-decoration: none;
        color: #eb401f;
        font-size: 16px;
    }

    .form-control:disabled, .form-control[readonly] {
        background: none;
        opacity: 1;
    }

    .timeline li p {
        height: 65px;
        overflow: hidden;
    }
</style>
